/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type privacyPolicyChangeNoticeQueryVariables = {
    userId: string;
    hasSessionCountryCode: boolean;
};
export type privacyPolicyChangeNoticeQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly createdDate: string | null;
        } | null;
        readonly regionalInfo?: ReadonlyArray<{
            readonly countryCode: string | null;
        } | null> | null;
    } | null;
};
export type privacyPolicyChangeNoticeQuery = {
    readonly response: privacyPolicyChangeNoticeQueryResponse;
    readonly variables: privacyPolicyChangeNoticeQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasSessionCountryCode",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdDate",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "countryCode",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "privacyPolicyChangeNoticeQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          },
          {
            "kind": "Condition",
            "passingValue": false,
            "condition": "hasSessionCountryCode",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "regionalInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "RegionalInfo",
                "plural": true,
                "selections": [
                  (v3/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "privacyPolicyChangeNoticeQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ]
          },
          (v4/*: any*/),
          {
            "kind": "Condition",
            "passingValue": false,
            "condition": "hasSessionCountryCode",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "regionalInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "RegionalInfo",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "privacyPolicyChangeNoticeQuery",
    "id": "ferrum/246.0.0-2020-01-09T09:21:36.050Z/privacyPolicyChangeNoticeQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '558015d75645348cffc8b0857a9c4acc';
export default node;
